import type { RouteObject } from 'react-router';

import { PERMISSIONS } from '@/constants/permissions';
import { ROUTES } from '@/constants/routes';
import { RequirePermission } from '@/features/auth';

export const prospectRoutes: RouteObject[] = [
  {
    element: <RequirePermission permission={PERMISSIONS.PROSPECTS_READ} />,
    children: [
      {
        path: ROUTES.ENQUIRIES,
        lazy: async () => ({ Component: (await import('./pages/ProspectsPage')).ProspectsPage }),
      },
    ],
  },
];
